import { gray, green } from "@ant-design/colors";
import { CheckOutlined, LoadingOutlined } from "@ant-design/icons";
import { Button, Card, Col, Flex, Row, Space, Spin, Typography } from "antd";
import ServiceApi from "apis/ServiceApi";
import { showNotification } from "common";
import { formatDateTimeDMY } from "helpers/formatDate";
import ModalExportInvoice from "pages/renewcert/components/ModalExportInvoice";
import { useEffect, useState } from "react";

export default function RenewCertEnd({ dataCheckReq }) {
  const [dataInfoCert, setDataInfoCert] = useState({});

  const [loadingPage, setLoadingPage] = useState(false);
  const [isVisibleCf, setIsVisibleCf] = useState(false);
  const [isExport, setIsExport] = useState(false);
  const [isModalExport, setIsModalExport] = useState(false);
  const [isOnlyExtend, setIsOnlyExtend] = useState(false);
  const [isOnlyChangeInfo, setIsOnlyChangeInfo] = useState(false);

  useEffect(() => {
    if (dataCheckReq) {
      if (
        dataCheckReq?.object !== 2 ||
        (dataCheckReq?.object === 2 && dataCheckReq?.isCompensation2025 === 2)
      ) {
        setIsExport(true);
      }
      if (dataCheckReq?.isCompensation2025 === 3) {
        setIsExport(true);
        if (dataCheckReq?.object ===2){
          setIsOnlyExtend(true);
        }
        if (dataCheckReq?.object ===4){
          setIsOnlyChangeInfo(true);
        }
      } else {
        setIsOnlyExtend(false);
        setIsOnlyChangeInfo(false);
      }
    }
  }, [dataCheckReq]);

   const actionText = isOnlyExtend
  ? "Gia hạn "
  : isOnlyChangeInfo
    ? "Thay đổi thông tin "
    : "Cấp bù ";
    
    
  useEffect(() => {
    getInfoNewCert().then(() => {
      setLoadingPage(true);
      setTimeout(() => {
        clickAutoEnd();
      }, 2000);
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const getInfoNewCert = async () => {
    setLoadingPage(true);
    try {
      const res = await ServiceApi.getCertInfoCapBu();
      if (res && res.status === 200 && res.data.data) {
        setDataInfoCert(res.data.data.data);
      } else {
        return null;
      }
    } catch (error) {
      console.error("error: ", error);
      showNotification("error", error.message, "Thông báo");
    } finally {
      setLoadingPage(false);
    }
  };

  const clickAutoEnd = async () => {
    setLoadingPage(true);
    try {
      const res = await ServiceApi.updateActiveStatusForProgram({
        idRequest: dataCheckReq.id,
        objectType: dataCheckReq.object,
      });
      if (res && res.status === 200) {
      }
    } catch (error) {
      console.error("error: ", error);
      showNotification("error", error.message, "Thông báo");
    } finally {
      setLoadingPage(false);
    }
  };
  const clickEnd = async () => {
    showNotification(
      "success",
      "Xác nhận chứng thư số thành công",
      "Thông báo",
    );
    setIsVisibleCf(true);
  };

  const clickExportInvoice = () => {
    setIsModalExport(true);
  };

 
  return (
    <div className="w-full">
      <Spin
        spinning={loadingPage}
        tip="Vui lòng đợi..."
        indicator={<LoadingOutlined style={{ fontSize: 24 }} spin />}
      >
        <Space direction="vertical" className="w-full" size={"large"}>
          <Flex justify="center">
            <div>
              <Flex justify="center">
                <Button
                  type="primary"
                  style={{ background: green.primary }}
                  shape="circle"
                  size="large"
                  icon={<CheckOutlined />}
                />
              </Flex>
              <Typography.Title level={3} className="text-center">
                {actionText}
                chứng thư số thành công!
              </Typography.Title>
              <div>
                Xác nhận thông tin để hoàn tất quá trình
                {" "}{actionText.toLowerCase()}
                chứng thư số của quý khách.
              </div>
            </div>
          </Flex>
          <div
          // style={{width:'960px'}}
          >
            <Card
              title={"Thông tin chứng thư số mới"}
              headStyle={{ minHeight: "45px" }}
              className="break-word  p-0 cs-card-border"
            >
              <Row className="certificate-item">
                <Col span={8}>Serial Number:</Col>
                <Col span={16} className="text-fw-500">
                  {dataInfoCert?.serinumberCert}
                </Col>
              </Row>
              <Row className="certificate-item">
                <Col span={8}>Subject DN:</Col>
                <Col span={16} className="text-fw-500">
                  {dataInfoCert?.subjectDN}
                </Col>
              </Row>
              <Row className="certificate-item">
                <Col span={8}>Phương thức sinh khoá:</Col>
                <Col span={16} className="text-fw-500">
                  {dataInfoCert?.generationMethod}
                </Col>
              </Row>

              <Row className="certificate-item">
                <Col span={8}>Thời gian hiệu lực của CTS:</Col>
                <Col span={16} className="text-fw-500">
                  Từ {formatDateTimeDMY(dataInfoCert.currentDateStart)} đến{" "}
                  {formatDateTimeDMY(dataInfoCert.currentDateEnd)}
                </Col>
              </Row>
              <Row className="certificate-item">
                <Col span={8}>Thời gian sử dụng dịch vụ:</Col>
                <Col span={16} className="text-fw-500">
                  Từ {formatDateTimeDMY(dataInfoCert.currentDateStart)} đến{" "}
                  {formatDateTimeDMY(dataInfoCert.certificateEnd)}
                </Col>
              </Row>
              <Row className="certificate-item">
                <Col span={8}>Gói dịch vụ:</Col>
                <Col span={16} className="text-fw-500">
                  {dataCheckReq.packageCode}
                </Col>
              </Row>
            </Card>
          </div>
        </Space>

        {(!isVisibleCf || isExport) && (
          <Row justify="center" className="w-full" style={{ padding: "2%" }}>
            <Space>
              {!isVisibleCf && (
                <Button type="primary" onClick={() => clickEnd()}>
                  Xác nhận
                </Button>
              )}
              {isExport && (
                <Button
                  type="primary"
                  onClick={() => clickExportInvoice()}
                  style={{ background: "#237804" }}
                >
                  Gửi yêu cầu xuất hoá đơn
                </Button>
              )}
            </Space>
          </Row>
        )}
        <div className="w-full">
          <Typography.Text type="danger" className="font-lg">
            <Typography.Text type="danger" strong className="font-lg">
              LƯU Ý:
            </Typography.Text>
            <ol>
              {isExport && (
                <li>
                  FastCA hỗ trợ xuất hoá đơn VAT khi khách hàng "Gửi yêu cầu
                  xuất hoá đơn" trong vòng 24 giờ
                </li>
              )}
              <li>
                Cập nhật
                <Typography.Text strong type="danger" className="font-lg">
                  {" "}
                  chứng thư số mới{" "}
                </Typography.Text>
                vào các tài khoản dịch vụ công (như Thuế, Bảo hiểm xã hội, Hải
                quan, Đấu thầu, Hóa đơn,…) và các ứng dụng dịch vụ phần mềm có
                sử dụng chứng thư số để tránh gián đoạn trong quá trình sử dụng
              </li>
            </ol>
          </Typography.Text>
        </div>
      </Spin>
      {isModalExport && (
        <ModalExportInvoice
          isOpen={isModalExport}
          setIsOpen={setIsModalExport}
          dataInfoCert={dataInfoCert}
          dataCheckReq={dataCheckReq}
          setIsExport={setIsExport}
        />
      )}
    </div>
  );
}
